var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalPawn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10648",
    "data-name": "Group 10648",
    transform: "translate(-4 -48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2352",
    "data-name": "Rectangle 2352",
    width: 20,
    height: 20,
    rx: 2,
    transform: "translate(4 48)",
    fill: "#f6f6f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10646",
    "data-name": "Group 10646",
    transform: "translate(0.027 0.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25040",
    "data-name": "Path 25040",
    d: "M34.615,35.566a.918.918,0,0,1,.951-.951,3.018,3.018,0,0,0,2.863-1.708,3.268,3.268,0,0,0-.162-3.189,3.162,3.162,0,0,0-2.661-1.472h0l-3.449-.2a3.89,3.89,0,0,0-4.11,4.109l.2,3.426a3.185,3.185,0,0,0,3.181,3.186,3.52,3.52,0,0,0,1.481-.338A3.005,3.005,0,0,0,34.615,35.566ZM30.144,37.6a2.4,2.4,0,0,1-1.108-2.041l-.2-3.449a3.1,3.1,0,0,1,3.093-3.278q.09,0,.18.005l3.472.2A2.385,2.385,0,0,1,37.6,30.144a2.49,2.49,0,0,1,.111,2.43,2.213,2.213,0,0,1-2.115,1.249,1.711,1.711,0,0,0-1.772,1.772,2.215,2.215,0,0,1-1.25,2.115A2.49,2.49,0,0,1,30.144,37.6Z",
    transform: "translate(-15.858 27.622)",
    fill: "#bf665e",
    stroke: "#bf665e",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25041",
    "data-name": "Path 25041",
    d: "M13.774,21.94a1.817,1.817,0,0,0-1.261.647c-.744.917-.366,2.465.843,3.45a3.285,3.285,0,0,0,2.033.783,2.456,2.456,0,0,0,.251-.013,1.817,1.817,0,0,0,1.261-.647c.744-.917.366-2.465-.843-3.45h0A3.186,3.186,0,0,0,13.774,21.94Zm2.512,3.722a1.06,1.06,0,0,1-.727.358,2.426,2.426,0,0,1-1.7-.6c-.856-.7-1.19-1.769-.729-2.338a1.06,1.06,0,0,1,.727-.358,1.625,1.625,0,0,1,.166-.008,2.525,2.525,0,0,1,1.536.6h0C16.414,24.022,16.748,25.093,16.286,25.662Z",
    transform: "translate(-6.251 31.314)",
    fill: "#bf665e",
    stroke: "#bf665e",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25042",
    "data-name": "Path 25042",
    d: "M12.031,39.473a3.471,3.471,0,0,0,1.064.172,2.672,2.672,0,0,0,1.229-.281,1.741,1.741,0,0,0,.9-1.028c.339-1.082-.538-2.336-1.955-2.794a3.019,3.019,0,0,0-2.293.109,1.743,1.743,0,0,0-.9,1.028C9.738,37.761,10.615,39.015,12.031,39.473Zm-1.2-2.557a.985.985,0,0,1,.508-.561,1.9,1.9,0,0,1,.867-.192,2.679,2.679,0,0,1,.819.133c.988.32,1.649,1.146,1.443,1.8a.984.984,0,0,1-.508.561,2.26,2.26,0,0,1-1.686.059C11.287,38.4,10.626,37.574,10.832,36.916Z",
    transform: "translate(-4.965 23.194)",
    fill: "#bf665e",
    stroke: "#bf665e",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25043",
    "data-name": "Path 25043",
    d: "M26.162,16.9a1.816,1.816,0,0,0,.647-1.261,3.183,3.183,0,0,0-.77-2.283c-.986-1.209-2.534-1.587-3.45-.843a1.816,1.816,0,0,0-.647,1.261,3.183,3.183,0,0,0,.77,2.284h0a3.118,3.118,0,0,0,2.317,1.225A1.771,1.771,0,0,0,26.162,16.9Zm-2.837-1.344h0a2.427,2.427,0,0,1-.6-1.7,1.059,1.059,0,0,1,.358-.727,1,1,0,0,1,.639-.208,2.359,2.359,0,0,1,1.7.937,2.427,2.427,0,0,1,.6,1.7,1.058,1.058,0,0,1-.358.727C25.094,16.747,24.023,16.413,23.325,15.557Z",
    transform: "translate(-12.168 37.231)",
    fill: "#bf665e",
    stroke: "#bf665e",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25044",
    "data-name": "Path 25044",
    d: "M36.681,10.076a1.742,1.742,0,0,0-1.028.9,3.019,3.019,0,0,0-.109,2.293A2.69,2.69,0,0,0,37.859,15.3a1.6,1.6,0,0,0,.479-.073,1.743,1.743,0,0,0,1.028-.9,3.02,3.02,0,0,0,.109-2.293C39.017,10.614,37.764,9.737,36.681,10.076Zm1.982,3.884a.984.984,0,0,1-.561.508c-.659.2-1.484-.455-1.8-1.443a2.26,2.26,0,0,1,.059-1.686.984.984,0,0,1,.561-.508.84.84,0,0,1,.251-.038,1.94,1.94,0,0,1,1.553,1.481A2.259,2.259,0,0,1,38.663,13.96Z",
    transform: "translate(-20.288 38.517)",
    fill: "#bf665e",
    stroke: "#bf665e",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalPawn);
export default __webpack_public_path__ + "static/media/animalPawn.d8459edd0e3cab2176b67fa330385383.svg";
export { ForwardRef as ReactComponent };